import { useState } from 'react';
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';
import { SessionProvider, type SessionState } from './SessionProvider';
import { SignInScreen } from './SignInScreen';
import { ResetScreen } from './ResetScreen';
import type { ReactNode } from 'react';

/**
 * Decides what an unauthenticated visitor sees.
 *
 * Three cases:
 *   signed-out  -> sign in, or reset if they ask
 *   must-reset  -> reset ONLY; the 366 migrated users land here and cannot
 *                  reach the app until they set a password (decision #7)
 *   ready       -> the portal
 */
export function AuthGate({ children }: { children: ReactNode }) {
  const [showReset, setShowReset] = useState(false);

  return (
    <SessionProvider
      fallback={
        <Stack sx={{ minHeight: '100dvh' }} alignItems="center" justifyContent="center">
          <CircularProgress size={28} />
        </Stack>
      }
      signedOut={(state: SessionState) => {
        if (state.status === 'must-reset') {
          return <ResetScreen forcedEmail={state.email} onDone={() => window.location.reload()} />;
        }
        return showReset ? (
          <ResetScreen onDone={() => setShowReset(false)} />
        ) : (
          <SignInScreen onReset={() => setShowReset(true)} />
        );
      }}
    >
      {children}
    </SessionProvider>
  );
}
